module.exports = __webpack_public_path__ + "static/media/2.5ac1f3c7.svg";